export default __webpack_public_path__ + "static/media/286.6ab99bc0.png";